import React from "react";
import { Route, Switch, useRouteMatch } from "react-router";

import CohortList from "./CohortList";
import CohortUserList from "./CohortUserList";

const Cohorts = (props) => {
	let { path } = useRouteMatch();

	return (
		<Switch>
			<Route exact path={`${path}`} component={CohortList} />
			<Route exact path={`${path}/:cohortID`} component={CohortUserList} />
			<Route path="*" component={() => <>404 NOT FOUND</>}></Route>
		</Switch>
	);
};

export default Cohorts;
